import api from 'src/config/api';
import {
	ICreateStudyAssignmentRequest,
	IGetCurrentUsersStudyAssignmentResponse,
	IGetNextStudyAssignmentResponse,
	IStudyAssignment,
	IUpdateStudyAssignmentRequest,
} from 'src/features/study_assignment/domain/types';

export const studyAssignmentApi = {
	createStudyAssignment: async (
		requestBody: ICreateStudyAssignmentRequest,
		siteSlug: string,
	): Promise<IStudyAssignment> => {
		const response = await api.post(
			'/api/v1/study-assignment',
			requestBody,
			{
				headers: {
					Site: siteSlug,
				},
			},
		);
		return response.data;
	},

	updateStudyAssignment: async (
		studyAssignmentId: number,
		requestBody: IUpdateStudyAssignmentRequest,
		siteSlug: string,
	): Promise<IStudyAssignment> => {
		const response = await api.patch(
			`/api/v1/study-assignment/${studyAssignmentId}`,
			requestBody,
			{
				headers: {
					Site: siteSlug,
				},
			},
		);
		return response.data;
	},

	getCurrentUserStudyAssignment: async (
		studyId: number,
		siteSlug: string,
	): Promise<IGetCurrentUsersStudyAssignmentResponse> => {
		const response = await api.get(
			`/api/v1/study/${studyId}/study-assignment`,
			{
				headers: {
					Site: siteSlug,
				},
			},
		);
		return response.data;
	},

	getNextStudyAssignment: async (
		siteSlug: string,
	): Promise<IGetNextStudyAssignmentResponse> => {
		const response = await api.get('/api/v1/study-assignment/next', {
			headers: {
				Site: siteSlug,
			},
		});
		return response.data;
	},
};
